import { render } from "./RankingWidget.vue?vue&type=template&id=7ba4ee3b&scoped=true"
import script from "./RankingWidget.vue?vue&type=script&lang=js"
export * from "./RankingWidget.vue?vue&type=script&lang=js"

import "./RankingWidget.vue?vue&type=style&index=0&id=7ba4ee3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba4ee3b"]])

export default __exports__